const colors = [
  { code: "0", color: "bg-black" },
  { code: "1", color: "bg-white" },
  { code: "2", color: "bg-cyan" },
  { code: "3", color: "bg-pink" },
  { code: "4", color: "bg-yellow" },
  { code: "5", color: "bg-purple" },
  { code: "6", color: "bg-green" },
  { code: "7", color: "bg-blue" },
];

export default colors;
